import BaseGiftCertificateItemModel from 'coreClasses/lineItemCtnr/GiftCertificateItemModel';

/**
 * Represents GiftCertificateItemModel
 */
class GiftCertificateItemModel extends BaseGiftCertificateItemModel {}

export default GiftCertificateItemModel;